import { NativeStackNavigationOptions } from "@react-navigation/native-stack";
import { FlatList, SafeAreaView } from "react-native";
import { Divider, List } from "react-native-paper";
import { useTailwind } from "tailwind-rn";
import { COUNTRY_LIST, Country } from "utils";

import Flag from "../../components/Flag";
import useLogin from "../../contexts/LoginContext";
import LoginHeader from "../../navigation/LoginHeader";
import { LoginScreenProps, loginRoutes } from "../../navigation/types";

export const phoneCountryScreenOptions: NativeStackNavigationOptions = {
  header: () => <LoginHeader title="País" />,
  animation: "fade_from_bottom",
};

type Props = LoginScreenProps<typeof loginRoutes.country>;
export default function PhoneCountryScreen({ navigation }: Props) {
  const { setCountry } = useLogin();

  const selectCountry = (country: Country) => {
    setCountry(country);
    navigation.goBack();
  };

  const tailwind = useTailwind();

  return (
    <SafeAreaView style={tailwind("flex-1")}>
      <FlatList
        data={COUNTRY_LIST}
        bounces={false}
        renderItem={({ item, index }) => {
          return (
            <List.Item
              title={item.name}
              left={() => (
                <Flag
                  source={item.logo}
                  style={tailwind("self-center")}
                  scale={1 / 2}
                />
              )}
              description={`+${item.code}`}
              style={tailwind("m-2")}
              key={index}
              onPress={() => selectCountry(item)}
            />
          );
        }}
        ItemSeparatorComponent={Divider}
      />
    </SafeAreaView>
  );
}
